module.exports = "<div class=\"modal-archismall\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">\n            <i class=\"\"></i>\n            Mail inviata\n        </h3>\n    </div>\n\n    <div class=\"modal-body\">\n        La mail è stata inviata con successo.\n    </div>\n\n    <div class=\"modal-footer\">\n        <a ng-click=\"$ctrl.ok()\">Ok</a>\n    </div>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/login/activation-mail-sent-modal/activation-mail-sent-modal.html
// module id = 486
// module chunks = 0